import React from "react";

const CategoryFilter = ({ categories, selected, onSelect }) => {
  // console.log("CATEGORIES:", categories);

  return (
    <div className="flex flex-wrap gap-4 mt-4 justify-center max-w-5xl mx-auto">
      {/* 🔘 Bouton All */}
      <button
        onClick={() => onSelect("all")}
        className={`px-4 py-2 rounded-full border transition-all ${
          selected === "all"
            ? "bg-[#FFA000]"
            : "border-gray-400 text-black hover:bg-[#FF98004D] hover:border-black"
        }`}
      >
        Toutes
      </button>

      {/* 🔁 Boutons des catégories */}
      {categories.map((cat) => (
        <button
          key={cat.id}
          onClick={() => onSelect(cat.id)}
          className={`px-4 py-2 rounded-full border transition-all ${
            selected === cat.id
              ? "bg-[#FFA000]"
              : "border-gray-400 text-black hover:bg-[#FF98004D] hover:border-black"
          }`}
        >
          {cat.nom}
        </button>
      ))}
    </div>
  );
};

export default CategoryFilter;
